import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import RenterDashboard from '@app/components/renter-dashboard/RenterDashboard';

const RenterDashboardPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle>{t('common.dashboard')}</PageTitle>
      <RenterDashboard />
    </>
  );
};

export default RenterDashboardPage;
